import React, {useState} from 'react';
import {FormControlLabel, FormGroup, Switch, Typography} from '@mui/material';
import type {DialogItem} from 'components/dialog/types';
import type {Feature} from 'configuration/types';
import {
  getBetaFeatures,
  getOptedInBetaFeatures,
  setOptedInBetaFeatures,
} from 'configuration';
import {useLocalization} from 'localization';
import {Dialog} from 'components/dialog';

type Props = {
  onClose: () => void;
};

export const BetaFeaturesDialog: React.FC<Props> = ({onClose}) => {
  const {t, tLoose} = useLocalization();
  const [optedIn, setOptedIn] = useState(getOptedInBetaFeatures);

  const handleToggle = (feature: Feature, checked: boolean) => {
    setOptedIn(current =>
      checked ? [...current, feature] : current.filter(f => f !== feature),
    );
  };

  const handleSave = () => {
    setOptedInBetaFeatures(optedIn);
    window.location.reload();
  };

  const dialogItems: DialogItem[] = [
    {
      itemType: 'action',
      alignLeft: true,
      title: t('general.cancel'),
      onClick: onClose,
    },
    {
      itemType: 'action',
      variant: 'contained',
      title: t('appbar.betaFeatures.save'),
      onClick: handleSave,
    },
  ];

  const body = (
    <>
      <Typography sx={{mb: 2}}>
        {t('appbar.betaFeatures.description')}
      </Typography>
      <FormGroup>
        {getBetaFeatures().map(feature => (
          <FormControlLabel
            key={feature}
            label={tLoose(`appbar.betaFeatures.feature.${feature}`)}
            control={
              <Switch
                checked={optedIn.includes(feature)}
                onChange={(_event, checked) => handleToggle(feature, checked)}
              />
            }
          />
        ))}
      </FormGroup>
    </>
  );

  return (
    <Dialog
      isOpen
      onClose={onClose}
      title={t('appbar.betaFeatures.title')}
      body={body}
      dialogItems={dialogItems}
      maxWidth="sm"
      fullWidth
    />
  );
};
